import * as store from "@/store";
import * as mutation from "./mutation-types";
import * as action from "./action-types";
import { deepCopyAxiosException } from "@/store/helpers";
import { userService } from "./service";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import axios from "axios";
import { GLOBAL_ERROR } from "../system/mutation-types";

export const actions = {
  async [action.SIGN_IN]({ commit, state }) {
    commit(mutation.SIGN_IN_STARTED);
    try {
      const userDetails = await userService.login(state.user.data);
     
      if (userDetails.requireAuthVerification) {
        commit(mutation.SIGN_IN_STARTED_REDIRECT_MFA_CHALLENGE, userDetails);
        return true;
      }
      
      commit(mutation.SIGN_IN_SUCCEEDED, userDetails);
      userService.startAutomaticLogoutChecking();
      return true;

    } catch (e) {
      commit(mutation.SIGN_IN_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.SIGN_OUT]({ commit }, logout = true) {
    let successful;
    try {
      userService.clearUserFromLocalStorage();
      if (logout) {
        await userService.logout();
      }
      commit(mutation.SIGN_OUT_SUCCEEDED);
      successful = true;
    } catch (e) {
      successful = false;
      commit(mutation.SIGN_OUT_FAILED, deepCopyAxiosException(e));
    } finally {
      userService.removeAuthFromAxiosRequests();
      store.resetState();
    }
    return successful;
  },

  async [action.CHANGE_PASSWORD]({ commit }, passwordDetails) {
    commit(mutation.CHANGE_PASSWORD_STARTED);
    try {
      const userDetails = await userService.changePassword(passwordDetails);
      commit(mutation.CHANGE_PASSWORD_SUCCEEDED, userDetails);
      commit(SHOW_NOTIFICATION, "Your password has been changed.");
      return true;
    } catch (e) {
      commit(mutation.CHANGE_PASSWORD_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.SIGN_IN_ATTEMPT_MFA_CHALLENGE]({ commit }, challengeAttemptInfo) {
    commit(mutation.SIGN_IN_STARTED_MFA_CHALLENGE);
    try {
      const result = await userService.attemptMfaChallenge(challengeAttemptInfo);
      commit(mutation.SIGN_IN_STARTED_MFA_CHALLENGE_SUCCESSFUL, result);

      if (result.verified) {
        userService.completeLogin(result.userSignInModel);
        commit(mutation.SIGN_IN_SUCCEEDED, result.userSignInModel);
        userService.startAutomaticLogoutChecking();
      }

      if (!result.verified && result.clearSession) {
        userService.clearUserFromLocalStorage();
      }

      return true;
    } catch (e) {
      commit(mutation.SIGN_IN_FAILED_MFA, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.WIDGETS_GET]({ commit, state }) {
    commit(mutation.WIDGETS_GET_STARTED);
    try {
      let { data } = await axios.get("/api/users/widgets");
      if (typeof data !== "object" || !data.Vsl || !data.Help || !data.Upfront) {
        commit(mutation.WIDGETS_INITIAL_SETUP);
        data = state.widgets.data;
      }
      commit(mutation.WIDGETS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.WIDGETS_GET_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.WIDGETS_SAVE]({ state, commit }, widgets) {
    const data = widgets || state.widgets.data;
    commit(mutation.WIDGETS_SAVE_STARTED, data);
    try {
      await axios.put("/api/users/widgets", data);
      commit(mutation.WIDGETS_SAVE_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.WIDGETS_SAVE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
